export const SAMPLE_FULL = {
  gr_doc_entry: 827058,
  invoice_number: "INV-2026-88431",
  invoice_date: "2026-03-23",
  lines: [
    { itemCode: "3661198", lineNum: 0, quantity: 1.0, unitPrice: 64.66 },
    { itemCode: "3602059", lineNum: 1, quantity: 1.0, unitPrice: 82.76 },
    { itemCode: "3635045", lineNum: 2, quantity: 1.0, unitPrice: 74.69 },
    { itemCode: "3615017", lineNum: 3, quantity: 6.0, unitPrice: 34.74 },
    { itemCode: "3661075", lineNum: 4, quantity: 2.0, unitPrice: 64.66 },
    { itemCode: "3635011", lineNum: 5, quantity: 2.0, unitPrice: 85.34 },
    { itemCode: "3636004", lineNum: 6, quantity: 3.0, unitPrice: 91.55 },
    { itemCode: "3615007", lineNum: 7, quantity: 3.0, unitPrice: 70.55 },
    { itemCode: "3603004", lineNum: 8, quantity: 1.0, unitPrice: 35.17 },
    { itemCode: "000002029", lineNum: 9, quantity: 1.0, unitPrice: 105.16 },
    { itemCode: "3615029", lineNum: 10, quantity: 4.0, unitPrice: 92.07 },
    { itemCode: "3645004", lineNum: 11, quantity: 1.0, unitPrice: 48.62 },
    { itemCode: "3635012", lineNum: 12, quantity: 3.0, unitPrice: 108.62 },
    { itemCode: "3635015", lineNum: 14, quantity: 1.0, unitPrice: 58.97 },
    { itemCode: "3615043", lineNum: 15, quantity: 3.0, unitPrice: 92.07 },
    { itemCode: "3603002", lineNum: 16, quantity: 40.0, unitPrice: 30.47 },
  ],
};

export const SAMPLE_MISMATCHED = {
  gr_doc_entry: 827058,
  invoice_number: "INV-2026-88431",
  invoice_date: "2026-03-23",
  complete_lines: [
    { itemCode: "3661198", lineNum: 0, quantity: 1.0, unitPrice: 64.66 },
    { itemCode: "3636004", lineNum: 6, quantity: 3.0, unitPrice: 91.55 },
    { itemCode: "3615007", lineNum: 7, quantity: 3.0, unitPrice: 70.55 },
    { itemCode: "3603004", lineNum: 8, quantity: 1.0, unitPrice: 35.17 },
    { itemCode: "000002029", lineNum: 9, quantity: 1.0, unitPrice: 105.16 },
    { itemCode: "3615029", lineNum: 10, quantity: 4.0, unitPrice: 92.07 },
    { itemCode: "3645004", lineNum: 11, quantity: 1.0, unitPrice: 48.62 },
    { itemCode: "3635012", lineNum: 12, quantity: 3.0, unitPrice: 108.62 },
    { itemCode: "3603002", lineNum: 16, quantity: 40.0, unitPrice: 30.47 },
  ],
  mismatched_lines: [
    {
      lineNum: 1,
      itemCode: "3602059",
      mismatch_type: "quantity",
      gr_quantity: 5.0,
      invoice_quantity: 3.0,
      invoice_unit_price: 82.76,
      gr_reference_price: null,
    },
    {
      lineNum: 2,
      itemCode: "3635045",
      mismatch_type: "price",
      gr_quantity: 1.0,
      invoice_quantity: 1.0,
      invoice_unit_price: 74.69,
      gr_reference_price: 68.0,
    },
    {
      lineNum: 3,
      itemCode: "3615017",
      mismatch_type: "both",
      gr_quantity: 6.0,
      invoice_quantity: 4.0,
      invoice_unit_price: 34.74,
      gr_reference_price: 30.0,
    },
    {
      lineNum: 4,
      itemCode: "3661075",
      mismatch_type: "both",
      gr_quantity: 2.0,
      invoice_quantity: 3.0,
      invoice_unit_price: 71.5,
      gr_reference_price: 64.66,
    },
    {
      lineNum: 5,
      itemCode: "3635011",
      mismatch_type: "quantity",
      gr_quantity: 2.0,
      invoice_quantity: 1.0,
      invoice_unit_price: 85.34,
      gr_reference_price: null,
    },
    {
      lineNum: 14,
      itemCode: null,
      mismatch_type: "unmatched",
      gr_quantity: 1.0,
      invoice_quantity: null,
      invoice_unit_price: null,
      gr_reference_price: null,
    },
    {
      lineNum: 15,
      itemCode: "3615043",
      mismatch_type: "price",
      gr_quantity: 3.0,
      invoice_quantity: 3.0,
      invoice_unit_price: 99.0,
      gr_reference_price: 92.07,
    },
  ],
};

export const SAMPLE_NOT_INVOICE = {
  transaction_key: "GR-123456",
  gr_doc_entry: 827058,
  invoice_number: null,
  invoice_date: null,
  not_invoice: true,
  complete_lines: [],
  mismatched_lines: [
    {
      lineNum: 0,
      itemCode: "3661198",
      mismatch_type: "unreadable",
      gr_quantity: 1.0,
      invoice_quantity: null,
      invoice_unit_price: null,
      gr_reference_price: null,
      tax_code: "V17",
      base_entry: 12345,
      base_line: 0,
      base_type: 22,
    },
  ],
};
